<template>
<div>

  <el-row>
    <el-col :span="17">
  <!-- 面包屑导航区域-->
  <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: '/home' }">Homepage</el-breadcrumb-item>
    <el-breadcrumb-item>Quotation</el-breadcrumb-item>
    <el-breadcrumb-item>Initiate Quotation</el-breadcrumb-item>
  </el-breadcrumb>
</el-col>
  <!-- <el-col class="el-breadcrumb__inner" font-size="3px" :span="6">
    Updating Time: {{ this.updateTime }}
    </el-col> -->
  </el-row>
  <!--卡片视图区域-->

  <el-card>
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <div style='text-align: center'>Quotation Form</div>
      <div style='overflow-y: scroll'>
        <!-- <el-table :data="deliveryList" border stripe style="width: 100%"> -->
      <table id="tableid" class="table-body" cellspacing=0 cellpadding=0>
        <tbody>
          <tr>
            <td width="10%" class="section-header">Brand</td>
            <td width="10%" class="section-header"><input type="text" v-model="project.brand" class="item-input"/></td>
            <td width="10%" class="section-header">Project Name</td>
            <td width="10%" class="section-header"><input type="text" v-model="project.projectName" class="item-input"/></td>
          </tr>
          <tr>
              <td width="100%" colspan="12" rowspan="1" class="section-header">PRODUCTION DETAILS</td>
          </tr>
          <tr>
            <td width="5%" class="section-header" colspan="1">Seq.</td>
            <td width="5%" class="section-header" colspan="1">Pictures</td>
            <td width="5%" class="section-header" colspan="1">Type</td>
            <td width="10%" class="section-header" colspan="1">Drawing No.</td>
            <td width="10%" class="section-header" colspan="1">Size-mm</td>
            <td width="5%" class="section-header" colspan="1">Material</td>
            <td width="10%" class="section-header" colspan="1">Details</td>
            <td width="10%" class="section-header" colspan="1">Deco</td>
            <td width="10%" class="section-header" colspan="1">Color</td>
            <td width="10%" class="section-header" colspan="1">Finish</td>
            <td width="10%" class="section-header" colspan="1">MOQ</td>
            <td width="10%" class="section-header" colspan="1">Delete</td>
          </tr>
          <tr v-for="(pi,index) in this.productItemList" v-bind:key="index">
            <td width="5%" colspan="1">{{ index }}</td>
            <div class="yanzRight">
            <input width="5%" v-bind:id="'evidence' + index"  @change="uploadImg($event,'preview' +  index,index)" type="file"/>
            </div>
            <div v-bind:id="'preview' + index">
            </div>
            <td width="5%" colspan="1"><input width="100%" type="text" v-model="pi.type" class="item-input"/></td>
            <td width="10%" colspan="1"><input width="100%" type="text" v-model="pi.drawingNbr" class="item-input"/></td>
            <td width="10%" colspan="1"><input width="100%" type="text" v-model="pi.sizeMm" class="item-input"/></td>
            <td width="5%" colspan="1"><el-select v-model="pi.material" collapse-tags
            size="mini" style="display: flex;"
            placeholder="please choose">
          <el-option
          v-for="item in materials"
          :key="item"
          :label="item"
          :value="item">
          <span style="float: left">{{ item }}</span>
        </el-option>
      </el-select>
            </td>
            <td width="10%" colspan="1"><input width="100%" type="text" v-model="pi.details" class="item-input"/></td>
            <td width="10%" colspan="1"><el-select v-model="pi.deco" collapse-tags
            size="mini" style="display: flex;"
            placeholder="please choose">
          <el-option
          v-for="item in deco"
          :key="item"
          :label="item"
          :value="item">
          <span style="float: left">{{ item }}</span>
        </el-option>
      </el-select>
              </td>
            <td width="10%" colspan="1"><input width="100%" type="text" v-model="pi.color" class="item-input"/></td>
            <td width="10%" colspan="1"><el-select v-model="pi.finish" collapse-tags
            size="mini" style="display: flex;"
            placeholder="please choose">
          <el-option
          v-for="item in finish"
          :key="item"
          :label="item"
          :value="item">
          <span style="float: left">{{ item }}</span>
        </el-option>
      </el-select>
      </td>
            <td width="10%" colspan="1"><input width="100%" type="text" v-model="pi.moq" class="item-input"/></td>
            <td width="10%" colspan="1"><div style="text-align:center"><i @click="delRow(index)" class="el-icon-delete" style="text-align:center"></i></div></td>
          </tr>
        </tbody>
      </table>
      </div>
      <el-button type="info" plain size="mini" @click="addRow">Add Row</el-button>
      <el-button type="primary" @click="onSend" id="sendId">Send</el-button>
      <el-button type="primary" @click="exportToExcel">Excel</el-button>
      <!-- </el-table> -->
    </el-form>
  </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      formInline: {
        fileList: [],
        brands: [],
        product: '',
        token: '',
        page: 1,
        rows: 100
      },
      project: {
        brand: '',
        projectName: ''
      },
      dialogImageUrl: '',
      imageUrl: '',
      dialogVisible: false,
      disabled: false,
      userName: '',
      productItemList: '',
      total: 0,
      productItem1: {
        id: '',
        img: '',
        picture: '',
        type: '',
        drawingNbr: '',
        sizeMm: '',
        material: '',
        details: '',
        deco: '',
        color: '',
        finish: '',
        moq: ''
      },
      productItem2: {
        id: '',
        img: '',
        picture: '',
        type: '',
        drawingNbr: '',
        sizeMm: '',
        material: '',
        details: '',
        deco: '',
        color: '',
        finish: '',
        moq: ''
      },
      productItem3: {
        id: '',
        img: '',
        picture: '',
        type: '',
        drawingNbr: '',
        sizeMm: '',
        material: '',
        details: '',
        deco: '',
        color: '',
        finish: '',
        moq: ''
      },
      productItem4: {
        id: '',
        img: '',
        picture: '',
        type: '',
        drawingNbr: '',
        sizeMm: '',
        material: '',
        details: '',
        deco: '',
        color: '',
        finish: '',
        moq: ''
      },
      productItem5: {
        id: '',
        img: '',
        picture: '',
        type: '',
        drawingNbr: '',
        sizeMm: '',
        material: '',
        details: '',
        deco: '',
        color: '',
        finish: '',
        moq: ''
      },
      // materials: '""'
      materials: ['ABS', 'Acrylic', 'Aluminum', 'AS', 'Cooper', 'Foam', 'Glass', 'Nylon', 'Other', 'Paper',
        'PBL', 'PCTA', 'PE', 'PET', 'PETG', 'PMMA', 'POM', 'PP', 'PS', 'PVC', 'Silicone', 'Steel', 'Surlyn', 'Tin', 'Wood', 'Zamac'],
      deco: ['Coating', 'Color', 'Degraded', 'Electroplating', 'Frosting', 'Hard', 'Hot Stamping', 'N/A', 'Natural',
        'No', 'Pad printing', 'Silk-screening', 'Soft touch', 'UV', 'Water transfer', 'vacum plating'],
      finish: ['Brushed', 'Fire', 'Floacking', 'Matt', 'N/A', 'No', 'Shiny', 'Varnish']
    }
  },
  created () {
    this.userName = window.sessionStorage.getItem('username')
    this.formInline.token = window.sessionStorage.getItem('token')
    this.productItemList = [this.productItem1, this.productItem2, this.productItem3,
      this.productItem4, this.productItem5]
    // this.materials = ['ABS', 'Acrylic', 'Aluminum', 'AS', 'Cooper', 'Foam', 'Glass', 'Nylon', 'Other', 'Paper',
    // 'PBL', 'PCTA', 'PE', 'PET', 'PETG', 'PMMA', 'POM', 'PP', 'PS', 'PVC', 'Silicone', 'Steel', 'Surlyn', 'Tin', 'Wood', 'Zamac']
  },
  methods: {
    test () {
      alert('rrrrrrrrrrrr')
    },
    async getBrands () {
      const { data: res } = await this.$http.get('/common/brandList', { params: this.brandParam })
      this.brandList = await res.brands
    },
    onSend () {
      console.log('send!')
      this.formInline.page = 1
      this.getMoqs()
    },
    exportToExcel () {
      /* 表示在当前页面打开新地址 */
      window.open('http://51.68.206.7:8081/show/exportMoq?token=' + encodeURIComponent(this.formInline.token) + '&brand=' + this.formInline.brands + '&product=' + this.formInline.product, '_parent')
    },
    async getMoqs () {
      var brandsStr = ''

      if (this.formInline.brands && this.formInline.brands.length) {
        // for (var i = numrc.length - 1; i >= 0; i--) {
        this.formInline.brands = [...this.formInline.brands].join(',')
        // alert('status  ===' + this.formInline.status)
        // console.log('this.formInline.brands111===' + this.formInline.brands)
        brandsStr = this.formInline.brands
      }
      const { data: res } = await this.$http.get('/show/moqList', { params: this.formInline })
      this.moqList = res.rows
      this.total = res.total
      if (res.rows && this.moqList[0]) {
        this.updateTime = this.moqList[0].createTime
        // console.log('this.scheduleList.createTime ===' + this.scheduleList[0].createTime)
      }

      if (brandsStr !== '') {
        await this.$set(this.formInline, 'brands', brandsStr.split(','))
      }

      console.log('aaa')
      console.log(res)
      console.log('ccc')
      // const res = await this.$http.get('/show/scheduleList', { params: this.formInline })
      // console.log(res)
    },
    dateFormat (row, column, cellValue, index) {
      const daterc = row[column.property]
      if (daterc === null || daterc === '' || daterc === '1753/01/01 00:00:00') {
        return
      }
      var date = new Date(daterc) // long转换成date
      var year = date.getFullYear().toString()
      var month = (date.getMonth() + 1)
      var day = date.getDate().toString()
      // if (month < 10) {
      //   month = '0' + month
      // }
      var monthLetterArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      var monthLetter = monthLetterArr[parseInt(month) - 1]
      if (day < 10) {
        day = '0' + day
      }
      return year + '-' + monthLetter + '-' + day
    },
    uploadImg (event, imgNum, index) {
      var widthImg = 200 // 显示图片的width
      var heightImg = 200 // 显示图片的height
      var div = document.getElementById(imgNum)
      // if (file.value !== "") {
      if (event.target.files && event.target.files[0]) {
        div.innerHTML = '<img id="upImg' + index + '">' // 生成图片
        var img = document.getElementById('upImg' + index) // 获得用户上传的图片节点
        img.onload = function () {
          img.width = widthImg
          img.height = heightImg
        }
        var reader = new FileReader() // 判断图片是否加载完毕
        reader.onload = function (evt) {
          if (reader.readyState === 2) { // 加载完毕后赋值
            img.src = evt.target.result
          }
        }
        reader.readAsDataURL(event.target.files[0])
      }
    },
    addRow () {
      var pi = {
        id: '',
        img: '',
        picture: '',
        type: '',
        drawingNbr: '',
        sizeMm: '',
        material: '',
        details: '',
        deco: '',
        color: '',
        finish: '',
        moq: ''
      }
      this.productItemList.push(pi)
    },
    delRow (rownum) {
      alert('rownum===' + rownum)
      this.productItemList.splice(rownum, 1)
      // var img = document.getElementById('upImg' + rownum)
      document.getElementById('upImg' + rownum).remove()
      document.getElementById('evidence' + rownum).value = ''
      // document.getElementById('upImg' + rownum).display = false
      // img.width = 0
      // img.height = 0
      // console.log(this.productItemList)
      // var test = new Array{['aa']; ['bb']; ['cc']}
      // test.splice(1,2)
      // alert('test.length ==' + test.length)
    },
    /* getObjectURL (file) {
                var url = null;
                if(window.createObjectURL!=undefined) {
                    url = window.createObjectURL(file) ;
                }else if (window.URL!=undefined) { // mozilla(firefox)
                    url = window.URL.createObjectURL(file) ;
                }else if (window.webkitURL!=undefined) { // webkit or chrome
                    url = window.webkitURL.createObjectURL(file) ;
                }
                return url ;
            }, */
    handleAvatarSuccess (res, file) {
      this.imageUrl = URL.createObjectURL(file.raw)
    },
    handleChange (file, fileList) {
      if (fileList.length > 0) {
        this.formInline.fileList = [fileList[fileList.length - 1]] // 这一步，是 展示最后一次选择的csv文件
      }
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },
    handleRemove (file) {
      console.log(file)
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleDownload (file) {
      console.log(file)
    }
  }
}
</script>

<style lang="less" scoped="scoped">
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
  .section-header {
    text-align: left;
    font-size: 15px;
    font-weight: bold;
    background-color: rgb(192,192,192);
  }
  .table-body {
    width: 100%;
    border-right: 1px solid #999;
    border-bottom: 1px solid #999;
    td {
      table-layout: fixed;
      border-collapse: collapse;
      border-top: 1px solid #999;
      border-left: 1px solid #999;
      border-spacing: 0;
    }
  }
  .item-input {
   width: 100%;
   height: 100%;
   align: center;
   background-color: white;
   // box-shadow: 0px 0px 0px #888888;
   /* // line-height: 20px;
   // padding-top: 3px;
   // padding-bottom: 3px;
   // border-radius: 4px;
   // border-top: 1px solid #999;
   // border-left: 1px solid #999;
   // border-bottom: 1px solid #999;
   // border-right: 1px solid #999;
   // box-shadow: 10 10 10px 1000px white inset !important; */
  }
</style>
